























import { Component, Emit, Mixins, VModel, Watch } from 'vue-property-decorator';

import ModelSetter from "../Mixins/ModelSetter";
import { warningNotificationWrapper } from "../logic/helpers/NotificationService";
import { threadIdIsCorrect } from "../shared/logic/Topics/TopicHelpers";
import TextInput from "./Pi/fields/TextInput/TextInput.vue";

@Component({
  components: {
    TextInput
  }
})
export default class BindTopicInput extends Mixins(ModelSetter) {
  @VModel({ type: [ String, Number ], default: '', required: false }) id!: string | number

  @Emit()
  pickTopicHandler(id: number) {
    return id
  }

  @Watch('id')
  onVModelChange(value: string | number) {
    this.threadId = value
  }

  threadId: string | number = ''

  prepareTopicId() {
    threadIdIsCorrect(this.threadId)
      .then(res => {
        this.pickTopicHandler(res)

        this.threadId = ''
      })
      .catch((err: Error) => {
        warningNotificationWrapper(this.$t('warning').toString(), this.$t(err.message).toString())
      })
  }

  mounted() {
    this.threadId = this.id ?? ''
  }
}
